var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"promo--detail-header"},[_c('div',[_c('div',{staticClass:"title--text"},[_vm._v(" "+_vm._s(_vm.banner.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }